import { render, staticRenderFns } from "./VorButton.vue?vue&type=template&id=a7dc74ec&"
import script from "./VorButton.vue?vue&type=script&lang=js&"
export * from "./VorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports